module.exports = "/_next/static/videos/02-video-39230a4907cc265c280707a3c422c233.mp4";